





























































import Vue from 'vue'
import { Table, TableColumn, Button } from 'element-ui'
import './TeamGroupList.scss'
// import SubscribeTeamGroups from '@/mixins/SubscribeTeamGroups'
import { KeyDict } from '@/types'
import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'
import { sortBy, isEmpty } from 'lodash'
import AddEditTeamGroup from '@/components/TeamGroupList/AddEditTeamGroup'
import { TeamGroup } from '@/types/teams'
import { UserProfile } from '@/types/users'

interface GroupMembersObject {
   ['groupId']?: UserProfile[]
}

//Templated off of TeamRoleList component
export default Vue.extend({
  name: 'TeamGroupList',
  mixins: [ ],
  props: {
    createNew: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  created () {
  },
  data: () => ({
    showAddEditModal: false,
    selectedTeamGroup: null as null | TeamGroup,
    selectedTeamGroupId: '',
    standardRoles: {} as KeyDict<TeamGroup>,
  }),
  watch: {
    createNew (newVal: boolean) {
      if (newVal) this.addGroup()
    }
  },
  computed: {
    canEditTeamGroup (): boolean {
      return this.$can(AbilityAction.Edit, AbilitySubject.TeamSettings)
    },
    canDeleteTeamGroup (): boolean {
      return this.$can(AbilityAction.Delete, AbilitySubject.TeamSettings)
    },
    //FIXME Already defined by SubscribeTeamGroups mixin. But we need it to prevent TS from complaining that `this.activeTeam` doesn't exist.
    activeTeam (): string {
      return this.$store.direct.state.team.activeTeam
    },
    teamMembers (): UserProfile[] {
      return this.$store.direct.state.team.currentTeam ?? []
    },
    teamGroups (): TeamGroup[] {
      return this.$store.direct.state.team.teamGroups ?? []
    },
    sortedTeamGroups (): TeamGroup[] {
      const r = sortBy(this.teamGroups, group => group.name.toLowerCase())
      //console.log(r)
      return r
    },
    groupMembers (): GroupMembersObject {
      const members: GroupMembersObject = {}
      this.teamGroups.forEach(group => {
        if (group.id) members[group.id] = this.teamMembers.filter(user => user.teamGroups?.[this.activeTeam]?.includes(group.id!))
      })
      return members
    }
  },
  methods: {
    compareByName (a:TeamGroup,b:TeamGroup) {
      const aL = a.name.toLowerCase()
      const bL = b.name.toLowerCase()
      return aL.localeCompare(bL)
    },
    compareByDescription (a:TeamGroup,b:TeamGroup){
      const aL = a.description?.toLowerCase() ?? ''
      const bL = b.description?.toLowerCase() ?? ''
      return aL.localeCompare(bL)
    },
    deleteGroup (groupId: string) {
      this.$confirm('Are you sure you want to delete this Member Group? This action is permanent and CANNOT be undone. Note that it will also be unassigned from all its members.', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$store.direct.dispatch.team.removeTeamGroup(groupId).then(() => {
          this.$message({
            type: 'success',
            message: 'Member Group deleted'
          })
        }).catch(error => {
          this.$message({
            type: 'error',
            message: 'Failed to delete Member Group: ' + error
          })
          console.error('Error deleteGroup', error)
        })
      }).catch(error => {
        console.log('remove member group cancelled', error)
      })
    },
    addGroup () {
      this.selectedTeamGroup = {
        team_id: this.activeTeam,
        name: '',
        description: ''
      }
      this.selectedTeamGroupId = ''
      this.showAddEditModal = true
    },
    editGroup (groupId: string) {
      if (groupId === '') {
        console.error('Member group id required for editing.')
        return
      }
      const teamGroup = this.teamGroups?.find(group => group.id === groupId)
      if (teamGroup === undefined) {
        console.warn(`Member group with id ${groupId} is no longer available.`)
        return
      }
      // Provide the modal with a copy so it doesn't modify the TeamGroup directly.
      this.selectedTeamGroup = teamGroup
      this.selectedTeamGroupId = groupId
      this.showAddEditModal = true
    },
    addEditDone (group: TeamGroup) {
      const newMembers = group.members ?? []
      delete group.members //Member list is not stored in groups in db
        if (this.selectedTeamGroupId === '') {
          this.$store.direct.dispatch.team.addTeamGroup({ group: group, userIds: newMembers }).then(() => {
            this.$message({
              type: 'success',
              message: 'Member Group added'
            })
          }).catch(error => {
            this.$message({
              type: 'error',
              message: 'Failed to add Member Group'
            })
            console.error('Error addEditDone add member group', error)
          })
        } else {
          this.$store.direct.dispatch.team.editTeamGroup({ group: {...group, id: this.selectedTeamGroupId}, userIds: newMembers }).then(() => {
            this.$message({
              type: 'success',
              message: 'Member Group updated'
            })
          }).catch(error => {
            this.$message({
              type: 'error',
              message: 'Failed to update Member Group'
            })
            console.error('Error addEditDone update member group', error)
          })
        }
      this.closeAddEditModal()
    },
    closeAddEditModal () {
      this.$emit('newDialogClosed', true)
      this.showAddEditModal = false
    },
    listGroupMembers (group: TeamGroup) {
      const memberNames: string[] = []
      if (group.id && this.groupMembers[group.id]) this.groupMembers[group.id].forEach(member => {
        let name = ''
        if (member.display_name) name = member.display_name
        else if (member.first_name && member.last_name) name = member.first_name + ' ' + member.last_name
        else if (member.first_name) name = member.first_name
        else if (member.last_name) name = member.last_name
        else name = 'N/A'
        memberNames.push(name)
      })
      return isEmpty(memberNames) ? 'None' : sortBy(memberNames, name => name.toLowerCase()).join(', ')
    }
  },
  components: {
    'el-table': Table,
    'el-table-column': TableColumn,
    'el-button': Button,
    AddEditTeamGroup
  }
})
